import NotificationsPage from "@Alternatives/Notifications/Pages/NotificationsPage.vue";

export const routes = [
    {
        path: "/portfolio/notifications/:workspaceId/:projectId",
        component: NotificationsPage
    },
    {
        path: "/decision/notifications/:workspaceId/:projectId",
        component: NotificationsPage
    },
]
